import { Action } from '@ngrx/store';
import { ViewState } from './view-state';
import { ITrainingDetailsDto, RequestStatus, CreateTrainingRequestDto } from '../../../../services/bpp.webapi/client';
import { CreateTrainingRequestAction } from '../../../../store/training/actions';
import { StatusHelper } from '../../../../helpers/statuses-helper';

export class AddState extends ViewState {

  constructor(training: ITrainingDetailsDto) {
    super();
    this.showStatus = false;
    this.isNew = true;
    this.setTraining(training);
  }

  public getAction(status: RequestStatus): Action {
    const request = new CreateTrainingRequestDto();
    request.status = status;
    request.trainingId = this.trainingId;
    request.participants = this.getParticipants();
    request.cameraOperator = this.cameras.cameraOperator;
    request.isOthersEnabled = this.others.require;
    request.isProducersEnabled = this.producers.require;
    request.isReportersEnabled = this.reporters.require;
    request.note = this.note;

    return new CreateTrainingRequestAction(request);
  }

  isReadOnly() {
    return false;
  }

  isCanChange() {
    return !StatusHelper.isDatePassed(this.startTime);
  }

  toggleState() {
  }

}
